import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
// import fr from './locales/fr.json'
import ja from './locales/ja.json'

// Get the user's preferred language from localStorage or browser settings
function getDefaultLocale() {
  const savedLocale = localStorage.getItem('user-locale')
  if (savedLocale) {
    return savedLocale
  }
  
  // Fallback to browser language
  const browserLocale = navigator.language.split('-')[0]
  // const supportedLocales = ['en']
  const supportedLocales = ['en', 'ja']
  // const supportedLocales = ['en', 'fr', 'ja']
  
  return supportedLocales.includes(browserLocale) ? browserLocale : 'en'
}

const messages = {
  en,
  ja,
  // fr
}

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: getDefaultLocale(),
  fallbackLocale: 'en',
  messages,
  globalInjection: true // Enable global $t
})

export default i18n

// Helper function to change language
export function setLocale(locale) {
  i18n.global.locale.value = locale
  localStorage.setItem('user-locale', locale)
  // Update document lang attribute for accessibility
  document.documentElement.lang = locale
}

// Helper function to get available locales
export function getAvailableLocales() {
  return [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    // { code: 'fr', name: 'Français', flag: '🇫🇷' },
  ]
}
